import {
  useConfiguratorStore,
  useProformQuery,
  useSetValueMutation,
} from '@eliadmin/core/src/stores/configurator-store';
import { isNullish } from '@eliadmin/core/src/utils/misc-utils';
import { useEffect, useMemo } from 'react';

export function ConfigurationOrnamentResetHandler() {
  const user_konf_id = useConfiguratorStore(s => s.user_konf_id);
  const confId = useProformQuery('GET_PRODUCT_CONF_ID', { user_konf_id });

  const fields = useMemo(() => {
    const fields: string[][][] = [];

    for (let i = 1; i <= 10; i++) {
      if (isNullish(confId.data.root.smako_conf.column[('user_m' + i) as 'user_m1'])) {
        break;
      }

      fields.push([
        [`user_m${i}`, confId.data.root.smako_conf.column[('user_m' + i) as 'user_m1']],
        [`user_m${i}_o`, confId.data.root.smako_conf.column[('user_m' + i + '_o') as 'user_m1_o']],
        [`user_m${i}_x`, confId.data.root.smako_conf.column[('user_m' + i + '_x') as 'user_m1_x']],
        [`user_m${i}_y`, confId.data.root.smako_conf.column[('user_m' + i + '_y') as 'user_m1_y']],
      ]);
    }

    return fields;
  }, [confId.data.root.smako_conf.column]);

  const mutation = useSetValueMutation();

  useEffect(() => {
    if (mutation.isPending) return;
    for (const field of fields) {
      if (!field[0][1] || field[0][1] === '0') {
        if (field[1][1]) mutation.mutate({ sloupec: field[1][0] as 'user_m1_o', value: '' });
        if (field[2][1]) mutation.mutate({ sloupec: field[2][0] as 'user_m1_x', value: '' });
        if (field[3][1]) mutation.mutate({ sloupec: field[3][0] as 'user_m1_y', value: '' });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...fields.flat().flat(), mutation.isPending]);

  return null;
}
